'use client';

import Link from 'next/link';
import { HeroSmartInput } from '@/components/onboarding/HeroSmartInput';
import { HERO_CTA_ENABLED } from '@/lib/onboarding/hero-cta-env';

export default function CTASection() {
  // Same compile-time gate as the hero: with the CTA live (call flag OR a
  // message number — Wave H1), the page's last word matches its first — the
  // same input, not a wizard detour. Gate off keeps the pre-launch closer.
  const callMeEnabled = HERO_CTA_ENABLED;

  return (
    <section className="py-24 bg-gradient-to-br from-[#111827] to-[#1F2937] text-center relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[conic-gradient(from_0deg,rgba(239,68,68,0.12),rgba(139,92,246,0.08),rgba(59,130,246,0.08),rgba(239,68,68,0.12))] rounded-full blur-[80px] pointer-events-none" />

      <div className="max-w-[1200px] mx-auto px-8 relative">
        <h2 className="text-[36px] md:text-[42px] font-bold tracking-[-1.5px] mb-4 text-white">
          Your first check-in can run this week.
        </h2>
        {callMeEnabled ? (
          <>
            <p className="text-[17px] text-white/60 mb-9 max-w-[520px] mx-auto">
              Say hello to Tessa — she drafts your check-in from that
              conversation and takes it from there. Free to start.
            </p>
            <div className="flex flex-col items-center">
              {/* This section is dark in BOTH themes, so the input's muted
                  semantic tokens are re-toned via the hsi-* hook classes. */}
              <HeroSmartInput surface="home_closer" className="mx-auto max-w-[560px] text-left [&_.hsi-muted]:text-white/60 [&_.hsi-strong]:text-white" />
              <Link
                href="/routines/new"
                className="text-[13px] text-white/50 underline-offset-4 hover:underline"
              >
                or start from a template →
              </Link>
            </div>
          </>
        ) : (
          <>
            <p className="text-[17px] text-white/60 mb-9 max-w-[480px] mx-auto">
              Pick a template, add your people, and Tessa takes it from there. Free to start.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Link
                href="/routines/new"
                className="inline-flex items-center justify-center gap-2 bg-[#EF4444] text-white px-8 py-4 rounded-full text-[16px] font-semibold shadow-[0_4px_14px_rgba(239,68,68,0.3)] hover:bg-[#DC2626] hover:-translate-y-0.5 transition-all"
              >
                Create your first routine &rarr;
              </Link>
              <Link
                href="#templates"
                className="inline-flex items-center justify-center px-8 py-4 border border-white/25 text-white rounded-full text-[16px] font-semibold hover:border-white hover:bg-white/[0.04] transition-all"
              >
                Browse templates
              </Link>
            </div>
          </>
        )}
        <div className="mt-8 flex flex-wrap gap-x-6 gap-y-2 justify-center text-[13px] text-white/40">
          <span>Private by design</span>
          <span>&middot;</span>
          <span>Aggregate-first reporting — no individual scoring</span>
          <span>&middot;</span>
          <span>Enterprise-ready</span>
          <span>&middot;</span>
          <span>GDPR-compliant</span>
        </div>
      </div>
    </section>
  );
}
